import React from 'react';
import Badge from '../ui/Badge';

const kpis = [
  { id: 'total', label: 'Total Items', valueKey: 'total' },
  { id: 'available', label: 'Available', valueKey: 'available' },
  { id: 'checkedOut', label: 'Checked Out', valueKey: 'checkedOut' },
  { id: 'overdue', label: 'Overdue', valueKey: 'overdue' },
  { id: 'underRepair', label: 'Under Repair', valueKey: 'underRepair' }
];

export default function InventoryKpis({ counts, activeKpi, onSelect }) {
  return (
    <div className="sp-kpi-grid" role="tablist" aria-label="Inventory KPIs">
      {kpis.map((kpi) => {
        const isActive = activeKpi === kpi.id;
        const value = counts[kpi.valueKey] ?? 0;
        return (
          <button
            key={kpi.id}
            type="button"
            className={`sp-kpi-card ${isActive ? 'sp-kpi-card--active' : ''}`}
            onClick={() => onSelect?.(kpi.id)}
            aria-pressed={isActive}
          >
            <div className="sp-kpi-label">{kpi.label}</div>
            <div className="sp-kpi-value">{value}</div>
            {kpi.id === 'overdue' && value > 0 && (
              <Badge variant="danger">Action needed</Badge>
            )}
          </button>
        );
      })}
    </div>
  );
}
